import React from 'react';
import './BuyDoggy.css';

/**
 * SECCIÓN 6: COMPRAR DOGGY — CTA Final
 * Pasos simples 1-2-3 + links directos
 * Diseñado para no asustar a normies
 */

const BuyDoggy = () => {

  return (
    <section className="buy-doggy section" id="comprar">
      <div className="container">

        <span className="buy-doggy__label">💰 La oportunidad</span>
        <h2 className="buy-doggy__title">Comprar $Doggy</h2>
        <p className="buy-doggy__subtitle">
          Puedes empezar desde <strong>$15 pesos</strong>.
        </p>

        {/* ===== VIDEO TUTORIAL ===== */}
        <div className="buy-doggy__video-wrap">
          <p className="buy-doggy__video-label">🎬 Mira lo fácil que es:</p>
          <div className="buy-doggy__video">
            <video
              controls
              playsInline
              preload="metadata"
              poster={`${process.env.PUBLIC_URL}/videos/tutorial_poster.jpg`}
              className="buy-doggy__video-player"
            >
              <source src={`${process.env.PUBLIC_URL}/videos/tutorial_comprar_doggy.mp4`} type="video/mp4" />
              Tu navegador no soporta video.
            </video>
          </div>
        </div>

        {/* ===== CTA PHANTOM ===== */}
        <div className="buy-doggy__phantom-wrap">
          <p className="buy-doggy__phantom-text">Necesitas una wallet para comprar $DOGGY:</p>
          <a
            href="https://phantom.app/download"
            target="_blank"
            rel="noopener noreferrer"
            className="buy-doggy__phantom-btn"
          >
            👻 Descargar Phantom
          </a>
        </div>

      </div>
    </section>
  );
};

export default BuyDoggy;
